import * as React from 'react';
import { IBoxProps } from '@lce/slice';
import { SuperLink } from '@lce/brand';

import * as Styled from './MessageBox.style'
import { scriptFunction } from '../../lib/util';
export interface MessageBoxProps extends IBoxProps {
  heading: string;
  link?: { 
    url: string; 
    text: string 
  };
  script: {
    text: string;
    size: string | null;
  }
  template: string;
  text?: string;
}

export const MessageBox: React.FC<MessageBoxProps> = ({ heading, link, script: { text: scriptText, size }, template, text, ...props }) => (
  <Styled.MessageBox data-testid="MessageBox" { ...props }>
    <Styled.Title>{ heading }</Styled.Title>
    { scriptText && <Styled.Script fontSize={ scriptFunction(size, template)}>{ scriptText }</Styled.Script> }
    { text && <Styled.Message>{ text }</Styled.Message> }
    { link && <Styled.Button as={SuperLink} href={ link.url }>{ link.text }</Styled.Button> }
  </Styled.MessageBox>
);
